<template>
  <div class="gold-panel">
    <div class="user_text">
      <span>{{ user ? user.name ? user.name : 'no name' : 'no name'}}</span>
    </div> 
    <div class="amount">
      <ul>
        <li>{{$t('gold')}}: <strong>{{user ? user.total_gold_amount ? user.total_gold_amount : 0 : 0}}g</strong></li>
        <li>{{$t('wallet')}}: {{user ? user.user_purse_details.wallet ? user.user_purse_details.wallet : 0 : 0}}</li>
        <li>MPoints: {{user ? user.user_purse_details.mcash ? user.user_purse_details.mcash : 0 : 0}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["user"])
  }
};
</script>